export const classes = {
  wrapper:
    'flex justify-start flex-wrap p-4 gap-4 bg-gradient-to-br from-[#FF6B35] via-[#FF8C61] to-[#FFB396]',
  condensedWrapper: 'grid grid-cols-7 gap-2.5',
  header: 'mb-3 flex items-end gap-2',
  title: 'text-base font-bold leading-none text-taupe-3 dark:text-mauve-1',
  subtitle: 'text-xs font-normal leading-[1.15] text-taupe-2 dark:text-mauve-2',
  orangeIcon: 'bg-orange-2',
  blueIcon: 'bg-blue-2',
  pinkIcon: 'bg-pink-2',
  cyanIcon: 'bg-cyan-2',
  greenIcon: 'bg-green-2',
};

export const styles = {
  wrapper: {
    backgroundImage:
      'linear-gradient(to right bottom, #ff8500, #ff9900, #ffac00, #ffbe00, #fed100)',
  },
};
